import { InputType } from "../components/sop/inputPanel";

export const formFields = {
  endpoint: "coursedetails",
  inputs: [
    {
      name: "course_type",
      label: "Selected Course Type",
      type: InputType.CountedAutoComplete,
      minLength: 2,
      maxLength: 100,
      required: true,
      options: [
        "Graduate",
        "Undergraduate",
        "Postgraduate",
        "PhD",
        "Masters",
        "Diploma",
        "Certificate",
      ],
    },
    {
      name: "course_selected",
      label: "Course Selected",
      placeholder: "Mtech. in Artificial Intelligence",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: false,
    },
    {
      name: "field_of_interest",
      label: "Field of Interest",
      placeholder: "Artificial Intelligence",
      type: InputType.CountedTextArea,
      minLength: 2,
      maxLength: 250,
      required: true,
      inputDependencies: ["course_selected"],
      helpType: "find_interest",

      assistance: true,
    },
    {
      name: "latest_education",
      label: "Your Latest Education",
      placeholder: "Btech. in Computer Science",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 200,
      // description: "Write about the Latest education you have done",
      required: true,
    },
    {
      name: "latest_education_level",
      label: "Latest Education Level",
      type: InputType.CountedAutoComplete,
      minLength: 2,
      maxLength: 200,
      options: [
        "Class 12th",
        "Class 10th",
        "Graduate",
        "Undergraduate",
        "Postgraduate",
        "PhD",
        "Masters",
        "Diploma",
        "Certificate",
      ],
    },

    {
      name: "latest_education_yop",
      label: "Your Latest Education's Year of Passing",
      placeholder: "2023",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "latest_education_score",
      label: "Your Latest Education Marks",
      placeholder: "9.0 CGPA on a scale of 10",
      type: InputType.CountedTextInput,
      minLength: 1,
      maxLength: 100,
      // description:
      //   "If using GPA, please mention like this, '8.5 on scale of 10'",
    },
    {
      name: "latest_education_institute",
      label: "Your Latest Education Institute/Board/University",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "relevant_subjects",
      label: "Relevant subject in last education",
      placeholder: "Artificial intelligence, Algorithms,Data Science",
      type: InputType.CountedTextArea,
      minLength: 2,
      maxLength: 250,
      // description: "Please write relevant course subjects",
      assistance: true,
      inputDependencies: ["course_selected", "latest_education"],
      helpType: "relevant_subjects",
      required: true,
    },
    {
      label: "Any work experience ?",
      type: InputType.InputCluster,
      required: false,
      cols: 2,
      fields: [
        {
          name: "previous_role",
          label: "Previous Work Role",
          placeholder: "Intern",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 200,
        },
        {
          name: "previous_company",
          label: "Previous Company Name",
          placeholder: "Google",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 200,
        },
        {
          name: "duration_of_work",
          label: "How long you work there?",
          placeholder: "6 months",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 200,
        },
      ],
    },
  ],
};

export default formFields;
